import { BaseTranslation } from 'src/i18n/i18n-types';

export const notifications: BaseTranslation = {
  title: 'Notifications',
  none: 'No notifications',
  noNew: 'No new notifications',
  viewAll: 'View all notifications',
  error: 'Error loading notifications, please refresh {error}',
};
